import { Button, Drawer, Tabs, Upload, message } from 'antd';
import { observer } from 'mobx-react-lite';
import Icon from '@components/Icon';
import ColorPicker from '@components/ColorPicker';
import stores from '@stores';
import colorSvg from '@assets/color.svg';
import { BackgroundSelect } from './BackgroundSelect';
import { useState } from 'react';

export default observer(({ showMore, onChange }) => {
    const [activeKey, setActiveKey] = useState('1');
    const [customImageUrl, setCustomImageUrl] = useState('');
    
    const onMoreClose = () => {
        onChange(false);
    }
    
    const handleCustom = (e) => {
        const color = e.toHexString();
        stores.option.frameConf.background = {
            type: 'solid',
            color
        }
    }
    
    const onSelectChange = (key) => {
        stores.option.setBackground(key);
    }
    
    const handleCustomImage = (info) => {
        if (info.file.status === 'done') {
            // 获取上传的图片URL
            const imageUrl = URL.createObjectURL(info.file.originFileObj);
            setCustomImageUrl(imageUrl);
            
            // 设置自定义图片作为背景
            stores.option.frameConf.background = {
                type: 'image',
                url: imageUrl
            };
            
            // 创建一个自定义背景键，使其在option.background中也能够跟踪
            const customKey = `custom_img_${Date.now()}`;
            
            // 设置自定义背景到option store
            stores.option.background = customKey;
            message.success('图片上传成功');
        } else if (info.file.status === 'error') {
            message.error('图片上传失败');
        }
    }
    
    const tabItems = [
        {
            key: '1',
            label: '纯色',
            children: (
                <>
                    <div className="py-2 flex items-center gap-2">
                        <ColorPicker onChange={handleCustom}>
                            <Button type="default" className="flex items-center" icon={<img src={colorSvg} width={18} className="mr-1" />}>
                                自定义颜色
                            </Button>
                        </ColorPicker>
                    </div>
                    <div className="py-2">
                        <BackgroundSelect type="solid" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '2',
            label: '渐变',
            children: (
                <>
                    <div className="py-2">
                        <p className="text-xs text-gray-500 mb-2">精美渐变背景可以为您的图片增添视觉上的层次感和动感</p>
                        <BackgroundSelect type="gradient" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '3',
            label: '纹理',
            children: (
                <>
                    <div className="py-2">
                        <p className="text-xs text-gray-500 mb-2">选择纹理背景可以为您的图片添加精致的质感</p>
                        <BackgroundSelect type="texture" onChange={onSelectChange} value={stores.option.background} />
                    </div>
                </>
            )
        },
        {
            key: '4',
            label: '图片',
            children: (
                <>
                    <div className="py-2">
                        <h4 className="text-sm font-bold py-1">上传图片</h4>
                        <p className="text-xs text-gray-500 mb-2">上传您自己的图片作为背景</p>
                        <Upload.Dragger
                            name="file"
                            multiple={false}
                            showUploadList={false}
                            customRequest={({ file, onSuccess }) => {
                                setTimeout(() => {
                                    onSuccess("ok");
                                }, 0);
                            }}
                            onChange={handleCustomImage}
                            accept="image/png,image/jpeg,image/webp"
                        >
                            {customImageUrl ? (
                                <div className="w-full p-2">
                                    <img src={customImageUrl} alt="背景图片" className="w-full rounded-md" />
                                    <p className="text-xs text-gray-500 mt-1">点击这里更换图片</p>
                                </div>
                            ) : (
                                <div className="p-4">
                                    <p className="ant-upload-drag-icon">
                                        <Icon.ImagePlus size={28} className="text-purple-500" />
                                    </p>
                                    <p className="text-sm">点击或拖拽图片到此区域上传</p>
                                    <p className="text-xs text-gray-500">支持PNG、JPG、WEBP格式</p>
                                </div>
                            )}
                        </Upload.Dragger>
                    </div>
                    <h4 className="text-sm font-bold py-2 mt-2">推荐图片</h4>
                    <p className="text-xs text-gray-500 mb-2">精选高质量背景图片，为您的作品增添专业效果</p>
                    <BackgroundSelect type="recommend" onChange={onSelectChange} value={stores.option.background} />
                </>
            )
        }
    ];
    
    return (
        <Drawer
            title="画布背景设置"
            placement="right"
            closable={true}
            mask={false}
            onClose={onMoreClose}
            open={showMore}
            getContainer={false}
            width="100%"
            extra={
                <Button
                    type="text"
                    size="small"
                    className="text-xs flex items-center opacity-80 m-0"
                    onClick={() => onChange(false)}
                >
                    返回
                </Button>
            }
            className="backdrop-drawer"
        >
            <div className="flex flex-col gap-2 h-full overflow-hidden">
                <div className="h-0 flex-1 overflow-y-auto px-2 py-2">
                    <Tabs
                        activeKey={activeKey}
                        onChange={setActiveKey}
                        items={tabItems}
                        className="bg-settings-tabs"
                    />
                </div>
            </div>
        </Drawer>
    )
});
